export enum ScheduleType {
  HEATING = 'heating',
  LIGHTING = 'lighting',
  CTA_SPEED = 'ctaSpeed',
  CTA_PRESSURE = 'ctaPressure',
  CTA_CO2 = 'ctaCo2',
  CTA_RETURN_TEMP_SETPOINT = 'ctaReturnTempSetpoint',
  AUTHORIZED_OFF = 'authorizedOff',
}
